import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const STATS = [{
  value: '+1000',
  label: 'docentes confían'
}, {
  value: '8',
  label: 'Tomos por tramo listos'
}, {
  value: '4,9/5',
  label: 'calificación ⭐'
}, {
  value: '🇺🇾',
  label: 'Todo Uruguay — primaria'
}];
export function PainAndProduct() {
  return <>
      {/* SECCIÓN 5: PRODUCTO */}
      <section className="py-20 px-4 bg-brand-deep text-white text-center relative overflow-hidden" data-id="element-96" data-mp="3kv0l9n0bjhqv">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-blue/40 rounded-full blur-[120px] pointer-events-none" data-id="element-97" data-mp="3pumuzmgxufux"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-98" data-mp="3fvxfg0cil7hu">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-5 py-2 rounded-full font-bold mb-8 text-[20px]" data-id="element-99" data-mp="3fudye7j1asf0">
            <span data-id="element-100" data-mp="24hjtx258h44z">🏆</span>        Ya l@s maestr@s de primaria en Uruguay nos eligen!
          </div>

          <div className="text-brand-orange font-bold tracking-widest text-sm mb-4 uppercase" data-id="element-101" data-mp="2dvlz5uy4ygr7">
            🌟 Tu Fénix Digital
          </div>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-display font-bold mb-8 text-white drop-shadow-lg" data-id="element-102" data-mp="28ylu9nd0vk1o">
            AULA DE <span className="text-brand-orange" data-id="element-103" data-mp="2muh659907uvk">ÉXITOS</span>
          </h2>

          <p className="text-xl md:text-2xl font-medium mb-8 max-w-2xl mx-auto text-brand-sky leading-relaxed" data-id="element-104" data-mp="2itnkynmy4u6d">
            El sistema de planificación anual más completo para docentes de
            primaria en Uruguay.
          </p>
          <p className="text-lg font-medium mb-12 text-gray-300" data-id="element-105" data-mp="36kt8loz4oqr8">
            100% PDF - Acceso inmediato - Alineado al Programa EBI de ANEP Uruguay 2026.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" data-id="element-106" data-mp="31mhydd4x8e8h">
            {STATS.map((stat, i) => <div key={i} className="bg-white/5 border border-white/10 rounded-2xl py-5 px-3 flex flex-col items-center justify-center backdrop-blur-sm" data-id="element-107" data-mp="3fjelb3hx5bk3" data-mpi={i}>
                <div className="text-2xl md:text-3xl font-display font-bold text-brand-orange mb-1" data-id="element-108" data-mp="28a1g0ghlx11f">
                  {stat.value}
                </div>
                <div className="text-xs text-gray-300 font-medium leading-tight" data-id="element-109" data-mp="2h9ok5a1q0ky6">
                  {stat.label}
                </div>
              </div>)}
          </div>

          <p className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-110" data-mp="2m2hq218xdzbu">
            Organizado en 4 tramos que cubren toda la educación primaria
            uruguaya:
          </p>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-111" data-mp="2w0npmc79etdj">
            {['Inicial', '1° y 2°', '3° y 4°', '5° y 6°'].map((tramo, i) => <div key={i} className="bg-white/10 border border-white/20 px-6 py-3 rounded-xl font-bold text-lg" data-id="element-112" data-mp="34yzcq48x3918" data-mpi={i}>
                {tramo}
              </div>)}
          </div>
        </div>
      </section>
    </>;
}